function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import ReactSlider from 'react-slider';
import { ValidPropTypes, makeErrorBoundComponent } from '@els/els-react--utils';
import classnames from 'classnames';
import PT from 'prop-types';
var defaults = {
  className: ""
};
var Slider = function Slider(_ref) {
  var _reactSliderProps$def, _reactSliderProps$def2;
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaults.className : _ref$className,
    reactSliderProps = _ref.reactSliderProps;
  var sliderClasses = classnames("c-els-slider", className, {
    "c-els-slider--range": ((_reactSliderProps$def = reactSliderProps.defaultValue) === null || _reactSliderProps$def === void 0 ? void 0 : _reactSliderProps$def.length) === 2,
    "c-els-slider--multi-range": ((_reactSliderProps$def2 = reactSliderProps.defaultValue) === null || _reactSliderProps$def2 === void 0 ? void 0 : _reactSliderProps$def2.length) >= 3,
    "c-els-slider--vertical": reactSliderProps.orientation === "vertical",
    // 'invert' is a JS object reserved term, so we need to use bracket notation
    // eslint-disable-next-line dot-notation
    "c-els-slider--inverted": reactSliderProps["invert"] === true
  });
  var compiledSliderProps = _objectSpread(_objectSpread({}, reactSliderProps), {}, {
    className: sliderClasses,
    trackClassName: "c-els-slider__track",
    thumbClassName: "c-els-slider__thumb",
    thumbActiveClassName: "c-els-slider__thumb--active",
    markClassName: "c-els-slider__mark"
  });
  return /* @__PURE__ */React.createElement(ReactSlider, _objectSpread({}, compiledSliderProps));
};
Slider.displayName = "Slider";
Slider.propTypes = {
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: PT.string,
  /** all props supported by react-slider */
  reactSliderProps: PT.object.isRequired
};
Slider.requiredProps = {
  reactSliderProps: ValidPropTypes.OBJECT
};
Slider.defaults = defaults;
var RawSlider = Slider;
var Slider$1 = makeErrorBoundComponent(RawSlider);
export { RawSlider, Slider$1 as Slider };
